"use client";
import React, { useEffect, useState } from "react";
import MoneyExchange from "./MoneyExchange.pc";
import JobClient from "../JobClient/JobClient.pc";
import styles from "./JobHeader.pc.module.scss";

const JobHeader = ({ sessionid, jobId, transData, data }) => {
  const [rate, setRate] = useState("");
  return (
    <div className={styles.jobHeader}>
      {data.is_pending_job ? <span className={styles.pending}>{data.pending_job_text}</span> : null}
      <h3>{transData.isOriginal ? data.job_title : data.translationTitle}</h3>
      <p className={styles.companyName}>{data.company_name}</p>

      <div className={styles.infoContent}>
        {data.is_urgent ? (
          <span className={styles.urgent}>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='14'
              height='14'
              viewBox='0 0 14 14'
              fill='none'
            >
              <path
                d='M9.99063 1.75049H5.78242C5.5868 1.75049 5.40953 1.86569 5.33008 2.04445L2.72389 7.90838C2.5784 8.23572 2.81801 8.60443 3.17623 8.60443H5.8415L4.53885 13.1637C4.48204 13.3625 4.72968 13.5044 4.87246 13.3548L11.5159 6.39503C11.8166 6.08003 11.5933 5.55823 11.1578 5.55823H8.8877L10.4334 2.46687C10.5979 2.13774 10.3586 1.75049 9.99063 1.75049Z'
                fill='black'
              />
            </svg>
            {data.urgent_text}
          </span>
        ) : null}
        <div className={styles.salaryInfo}>
          {rate || data.salary_info.text}
          {data.salary_info.type_text ? (
            <span className={styles.type}>[{data.salary_info.type_text}]</span>
          ) : null}
          <MoneyExchange
            data={data?.salary_info}
            handleClick={(value) => {
              setRate(value);
            }}
          />
        </div>
        <div className={styles.detailInfo}>
          {data.location ? <span>{data.location}</span> : null}
          {data.location ? (
            <span>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='2'
                height='3'
                viewBox='0 0 2 3'
                fill='none'
              >
                <circle cx='0.75' cy='1.45508' r='0.75' fill='#515151' />
              </svg>
            </span>
          ) : null}
          {data.xp_lvl ? <span>{data.xp_lvl}</span> : null}
          {data.xp_lvl ? (
            <span>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='2'
                height='3'
                viewBox='0 0 2 3'
                fill='none'
              >
                <circle cx='0.75' cy='1.45508' r='0.75' fill='#515151' />
              </svg>
            </span>
          ) : null}
          {data.degree ? <span>{data.degree}</span> : null}
          {data.degree ? (
            <span>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='2'
                height='3'
                viewBox='0 0 2 3'
                fill='none'
              >
                <circle cx='0.75' cy='1.45508' r='0.75' fill='#515151' />
              </svg>
            </span>
          ) : null}
          {data.job_type ? <span>{data.job_type}</span> : null}
        </div>
      </div>
      <JobClient data={data?.allData} sessionid={sessionid} jobId={jobId} />
    </div>
  );
};

export default JobHeader;
